import { render, staticRenderFns } from "./UserPlanDetails.vue?vue&type=template&id=84969136"
import script from "./UserPlanDetails.vue?vue&type=script&lang=js"
export * from "./UserPlanDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports